(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["famille-ferus-hero"] && !Shopify.designMode) return;
  try {
    (() => {
    const activeHeroes = new Map();

    // Plays only the loop that is displayed (desktop or phone), only while the hero is on screen,
    // and not at all when the visitor asked for reduced motion or data saving, until they press Play.
    const setUpVideo = (hero) => {
      const videos = [...hero.querySelectorAll('[data-fg-hero-video]')];
      const toggle = hero.querySelector('[data-fg-hero-toggle]');
      if (!videos.length) return () => {};
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      const phone = window.matchMedia('(max-width: 599px)');
      const saveData = Boolean(navigator.connection && navigator.connection.saveData);
      const state = { userPaused: false, userPlayed: false, refused: false, inView: true };
      const wanted = () => !state.userPaused && !state.refused && (state.userPlayed || (!reduce.matches && !saveData));
      const render = () => {
        if (!toggle) return;
        const playing = wanted();
        toggle.textContent = playing ? toggle.dataset.pauseText : toggle.dataset.playText;
        toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      };
      const sync = () => {
        const current = videos.find((video) => video.offsetParent !== null) || null;
        const run = wanted() && state.inView && document.visibilityState === 'visible';
        videos.forEach((video) => { if (video !== current || !run) video.pause(); });
        if (current && run && current.paused) {
          const started = current.play();
          if (started && started.catch) {
            started.catch((error) => {
              if (error && error.name === 'AbortError') return;
              state.refused = true;
              render();
            });
          }
        }
        render();
      };
      const onToggle = () => {
        if (wanted()) {
          state.userPaused = true;
          state.userPlayed = false;
        } else {
          state.userPaused = false;
          state.userPlayed = true;
          state.refused = false;
        }
        sync();
      };
      if (toggle) {
        toggle.hidden = false;
        toggle.addEventListener('click', onToggle);
      }
      const io = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
          state.inView = entries[entries.length - 1].isIntersecting;
          sync();
        }, { threshold: 0 })
        : null;
      if (io) io.observe(hero);
      const listen = (query) => {
        if (query.addEventListener) query.addEventListener('change', sync);
        else if (query.addListener) query.addListener(sync);
      };
      const unlisten = (query) => {
        if (query.removeEventListener) query.removeEventListener('change', sync);
        else if (query.removeListener) query.removeListener(sync);
      };
      listen(reduce);
      listen(phone);
      document.addEventListener('visibilitychange', sync);
      sync();
      return () => {
        if (io) io.disconnect();
        unlisten(reduce);
        unlisten(phone);
        document.removeEventListener('visibilitychange', sync);
        if (toggle) toggle.removeEventListener('click', onToggle);
        videos.forEach((video) => video.pause());
      };
    };

    const initializeHeroes = () => {
      activeHeroes.forEach((cleanup, hero) => {
        if (!hero.isConnected) {
          cleanup();
          activeHeroes.delete(hero);
        }
      });

      document.querySelectorAll('.fg-ferus-hero').forEach((hero) => {
        if (activeHeroes.has(hero)) return;

        const updateHeight = () => {
          const offset = Math.max(0, hero.getBoundingClientRect().top + window.scrollY);
          hero.style.setProperty('--fg-ferus-header-height', `${offset}px`);
        };
        const observer = new ResizeObserver(updateHeight);
        document.querySelectorAll('.shopify-section-group-header-group').forEach((header) => observer.observe(header));
        window.addEventListener('resize', updateHeight, { passive: true });
        document.fonts.ready.then(() => { if (hero.isConnected) updateHeight(); });
        updateHeight();
        const stopVideo = setUpVideo(hero);

        activeHeroes.set(hero, () => {
          observer.disconnect();
          window.removeEventListener('resize', updateHeight);
          stopVideo();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeHeroes, { once: true });
    } else {
      initializeHeroes();
    }
    document.addEventListener('shopify:section:load', initializeHeroes);
    document.addEventListener('shopify:section:unload', initializeHeroes);
  })();
  } catch(e) { console.error(e); }
})();

})();
